export enum PeriodEnum {
  DAY = 'day',
}
